import { MONDAY_AGENTS_HEADER_LINK, MONDAY_AI_WORKFLOWS_HEADER_LINK, MONDAY_SIDEKICK_HEADER_LINK, MONDAY_NOTETAKER_HEADER_LINK, MONDAY_VIBE_HEADER_LINK, DASHBOARDS_PAGE_LINK, WORKDOCS_PAGE_LINK, FORMS_PAGE_LINK, INTEGRATIONS_PAGE_LINK, AUTOMATIONS_PAGE_LINK, MONDAY_DB_PAGE_LINK, MCP_PAGE_LINK, DEPARTMENTS_PMO_LINK, DEPARTMENTS_IT_LINK, DEPARTMENTS_LEGAL_LINK, DEPARTMENTS_MARKETING_LINK, DEPARTMENTS_HR_LINK, OPERATIONS_CLUSTER_LINK, CRM_SALES_PAGE_LINK } from "constants/links";
const avatarUrl = (filename)=>`https://dapulse-res.cloudinary.com/image/upload/AI%20homepage%202026/${filename}`;
export const USE_CASES = [
    {
        iconUrl: avatarUrl("Menu2026-AIPlatfromMulti-product-pmo-N6vmE.png"),
        titleKey: "header.tabs.solution.pmo",
        descKey: "header.tabs.aiPlatform.useCase.pmo.description",
        link: DEPARTMENTS_PMO_LINK
    },
    {
        iconUrl: avatarUrl("Menu2026-AIPlatfromMulti-product-marketing-AXkY4.png"),
        titleKey: "header.tabs.solution.marketing",
        descKey: "header.tabs.aiPlatform.useCase.marketing.description",
        link: DEPARTMENTS_MARKETING_LINK
    },
    {
        iconUrl: avatarUrl("Menu2026-AIPlatfromMulti-product-operations-zuIDm.png"),
        titleKey: "header.tabs.solution.operations",
        descKey: "header.tabs.aiPlatform.useCase.operations.description",
        link: OPERATIONS_CLUSTER_LINK
    },
    {
        iconUrl: avatarUrl("Menu2026-AIPlatfromMulti-product-it-Ir59m.png"),
        titleKey: "header.tabs.solution.it",
        descKey: "header.tabs.aiPlatform.useCase.it.description",
        link: DEPARTMENTS_IT_LINK
    },
    {
        iconUrl: avatarUrl("Menu2026-AIPlatfromMulti-product-hr-bjqrP.png"),
        titleKey: "header.tabs.solution.hr",
        descKey: "header.tabs.aiPlatform.useCase.hr.description",
        link: DEPARTMENTS_HR_LINK
    },
    {
        iconUrl: avatarUrl("Menu2026-AIPlatfromMulti-product-sales-htyHG.png"),
        titleKey: "header.tabs.solution.sales",
        descKey: "header.tabs.aiPlatform.useCase.sales.description",
        link: CRM_SALES_PAGE_LINK
    },
    {
        iconUrl: avatarUrl("Menu2026-AIPlatfromMulti-product-legal.png"),
        titleKey: "header.tabs.solution.legal",
        descKey: "header.tabs.aiPlatform.useCase.legal.description",
        link: DEPARTMENTS_LEGAL_LINK
    }
];
export const AGENTS_CAPABILITY_ITEMS = [
    {
        labelKey: "header.tabs.aiPlatform.capabilities.agentBuilder",
        link: MONDAY_AGENTS_HEADER_LINK
    },
    {
        labelKey: "header.tabs.aiPlatform.capabilities.aiAssistant",
        link: MONDAY_SIDEKICK_HEADER_LINK
    },
    {
        labelKey: "header.tabs.aiPlatform.capabilities.notetaker",
        link: MONDAY_NOTETAKER_HEADER_LINK
    },
    {
        labelKey: "header.tabs.aiPlatform.capabilities.aiWorkflows",
        link: MONDAY_AI_WORKFLOWS_HEADER_LINK
    }
];
export const WORK_SURFACE_CAPABILITY_ITEMS = [
    {
        labelKey: "header.tabs.aiPlatform.capabilities.vibeCoding",
        link: MONDAY_VIBE_HEADER_LINK
    },
    {
        labelKey: "header.tabs.aiPlatform.capabilities.dashboards",
        link: DASHBOARDS_PAGE_LINK
    },
    {
        labelKey: "header.tabs.features.keyFeatures.docs.title",
        link: WORKDOCS_PAGE_LINK
    },
    {
        labelKey: "header.tabs.features.keyFeatures.forms.title",
        link: FORMS_PAGE_LINK
    }
];
export const ANY_TOOL_CAPABILITY_ITEMS = [
    {
        labelKey: "header.tabs.products.integrations",
        link: INTEGRATIONS_PAGE_LINK
    },
    {
        labelKey: "header.tabs.products.automations",
        link: AUTOMATIONS_PAGE_LINK
    },
    {
        labelKey: "header.tabs.aiPlatform.capabilities.infra",
        link: MONDAY_DB_PAGE_LINK
    },
    {
        labelKey: "header.tabs.aiPlatform.capabilities.mcp",
        link: MCP_PAGE_LINK
    }
];
export const CAPABILITY_SECTIONS = [
    {
        groupKey: "header.tabs.aiPlatform.capabilities.group.agents",
        items: AGENTS_CAPABILITY_ITEMS
    },
    {
        groupKey: "header.tabs.aiPlatform.capabilities.group.workSurface",
        items: WORK_SURFACE_CAPABILITY_ITEMS
    },
    {
        groupKey: "header.tabs.aiPlatform.capabilities.group.anyTool",
        items: ANY_TOOL_CAPABILITY_ITEMS
    }
];
